module.exports = __webpack_public_path__ + "img/khanda.c8261029.svg";